import { useState, useEffect } from 'react';
import { Row, Col, Spin, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import mortgageIcon from '../../../assets/icons/mortgageIcon.svg';
import SwapSubrogation from '../../../assets/onboarding/SwapSubrogation.svg';
import HomeMortgage from '../../../assets/onboarding/HomeMortgage.svg';
import { isMobileOnly } from 'react-device-detect';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import env from '../../../environment';
import { useNavigate } from 'react-router-dom';
import { dataSummary } from '../../../store/data/actions';

const { Text } = Typography;

const RedirectToSabadell = ({}) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const userToken = useSelector((state) => state.auth.token);
	const dataProfile = useSelector((state) => state.data.dataProfile);
	const dataSummaryOp = useSelector((state) => state.data.dataSummary);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		sessionStorage.setItem('modalSub', false);
		dispatch(dataSummary(userToken));
	}, []);

	useEffect(() => {
		dataSummaryOp?.length !== 0 && getOperationData(dataSummaryOp[0]);
	}, [dataSummaryOp]);

	const getOperationData = (operation) => {
		axios
			.get(`${env.api.url}/operations/operation/operationData/${operation.operationId}/client`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				if (response.data.success) {
					if (response.data.data.process.operationTypeToBeDefined) {
						navigate('/operationNew');
					} else {
						navigate(`/operations/${operation.operationId}/${operation.stage}`);
					}
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};
	if (loading) {
		return (
			<div style={{ textAlign: 'center', height: '100vh' }}>
				<Spin style={{ position: 'absolute', top: '50%' }} size="large" />
			</div>
		);
	} else {
		return (
			<div
				className={isMobileOnly ? 'desktop-background-mobile' : 'desktop-background'}
				style={{ marginBottom: isMobileOnly && 100 }}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						maxWidth: isMobileOnly ? 300 : 746,
						margin: 'auto',
						textAlign: 'center',
						position: 'relative',
						top: '42%'
					}}>
					<div>
						<Text style={{ color: '#212121', fontSize: isMobileOnly ? 18 : 32, fontWeight: 700 }}>
							{t('noMortgages.intoPlatformSabadell')}
						</Text>
					</div>
				</div>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						maxWidth: isMobileOnly ? 300 : 746,
						margin: 'auto',
						textAlign: 'center',
						position: 'relative',
						top: '45%'
					}}>
					<a
						href="https://www.bancsabadell.com/simulador-hipoteca"
						style={{ color: '#006DFF', fontSize: isMobileOnly ? 18 : 24, fontWeight: 700 }}>
						{t('www.bancsabadell.com/simulador-hipoteca')}
					</a>
				</div>
			</div>
		);
	}
};

export default RedirectToSabadell;
